// content-1.twig

import React from 'react'
import styled from 'styled-components'

import {Headline, Content} from '@miro-site/components_utils'

import {
  AccordionButton,
  Section,
  UnorderedList,
  ListItem,
  Container,
  Box,
  Centered,
} from '@miro-site/core'

export interface Item {
  headline?: React.ComponentProps<typeof Headline>
  content?: React.ComponentProps<typeof Content>
  list?: React.ReactNode[]
}

export interface FaqProps {
  headline: React.ComponentProps<typeof Headline>
  items: Item[]
}

const AccordionWrapper = styled(Box).attrs({
  as: 'ul',
  $mt: [40, 80],
  $styles: {listStyle: 'none'},
})``

const Faq: React.FC<FaqProps> = ({headline, items}) => {
  return (
    <Section data-place="FAQ section" type="large">
      <Container>
        {headline?.text && (
          <Centered>
            <Headline {...headline} size={headline.size || 'mid'} tag={headline.tag || 'h2'} />
          </Centered>
        )}
        {items?.length && (
          <AccordionWrapper>
            {items.map((item, index) => {
              if (!item.headline?.text) {
                return null
              }
              let content = item.content && <Content {...item.content}></Content>
              if (!content && item.list) {
                content = (
                  <UnorderedList $variant="default">
                    {item.list.map((listItem, index) => (
                      <ListItem key={index}>{listItem}</ListItem>
                    ))}
                  </UnorderedList>
                )
              }

              return (
                <AccordionButton
                  key={index}
                  id={index + ''}
                  headline={
                    <Headline
                      {...item.headline}
                      size={item.headline.size || 'tiny'}
                      tag={item.headline.tag || 'div'}
                    />
                  }
                  content={content}
                />
              )
            })}
          </AccordionWrapper>
        )}
      </Container>
    </Section>
  )
}

Faq.defaultProps = {
  headline: {
    text: 'FAQ',
    size: 'medium',
    align: 'center',
  },
}

export default Faq
